import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { GUIDES } from "@/data/site";
import QuoteCTA from "@/components/QuoteCTA";
import { Reveal, Kicker, MaskedLine } from "@/components/Reveal";

export default function GuideDetail() {
  const { slug } = useParams();
  const g = GUIDES.find((x) => x.slug === slug);
  const others = GUIDES.filter((x) => x.slug !== slug).slice(0, 3);

  if (!g)
    return (
      <div className="px-5 pb-32 pt-48 text-center" data-testid="guide-not-found">
        <p className="font-display text-4xl">Guide not found.</p>
        <Link to="/guides" className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-kwila">
          <ArrowLeft size={15} /> All guides
        </Link>
      </div>
    );

  return (
    <div data-testid="guide-detail-page">
      <section className="px-5 pb-14 pt-32 md:px-10 md:pt-40">
        <div className="mx-auto max-w-[900px]">
          <Link
            to="/guides"
            data-testid="guide-back-link"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-sand transition-colors hover:text-kwila"
          >
            <ArrowLeft size={14} /> All Guides
          </Link>
          <div className="mt-8">
            <Kicker>{g.tag} · {g.readTime}</Kicker>
            <h1 className="mt-4 font-display text-4xl font-light leading-tight tracking-tight md:text-6xl">
              <MaskedLine delay={0.1}>{g.title}</MaskedLine>
            </h1>
          </div>
        </div>
      </section>

      <section className="px-5 md:px-10">
        <Reveal className="mx-auto max-w-[1100px]">
          <div className="overflow-hidden rounded-sm">
            <img src={g.image} alt={g.title} className="aspect-[21/9] w-full object-cover" />
          </div>
        </Reveal>
      </section>

      <section className="px-5 py-16 md:px-10 md:py-20">
        <div className="mx-auto max-w-[760px]">
          {g.sections.map((s) => (
            <Reveal key={s.h} className="mb-10">
              <h2 className="font-display text-2xl tracking-tight md:text-3xl">{s.h}</h2>
              {s.p.map((para) => (
                <p key={para.slice(0, 24)} className="mt-4 text-base leading-relaxed text-ink/75">
                  {para}
                </p>
              ))}
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-stone/60 px-5 py-20 md:px-10">
        <div className="mx-auto max-w-[1100px]">
          <Reveal className="mb-8">
            <Kicker>Keep Reading</Kicker>
          </Reveal>
          <div className="grid gap-8 md:grid-cols-3">
            {others.map((o) => (
              <Link key={o.slug} to={`/guides/${o.slug}`} data-testid={`guide-more-${o.slug}`} className="group">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-sand">{o.tag}</p>
                <h3 className="mt-1 font-display text-2xl leading-tight tracking-tight transition-colors group-hover:text-kwila">
                  {o.title}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
